<template>
    <div name="banner" class="banner">
        <div class="float-button" id="float-button" @click="appDown">솔닥 앱 다운로드</div>
        <video autoplay muted loop playsinline class="bg-video" preload="auto">
            <source src="../assets/intro.mp4" type="video/mp4">
        </video>
        <div class="bg-block">
        </div>
        <img class="bg-logo" 
            src="../assets/logo_soldoc.png"
        />
        <div class="center-area">
            <span class="text-sub">비대면진료 소비자만족지수 1위</span>
            <span class="text-title">병원가기 힘들 땐<br/> 솔닥 비대면진료</span>
            <div class="down-button" @click="appDown">
                <img class="download-logo" src="../assets/download.png"/>
                앱 다운로드
            </div>
        </div>
        <span class="bottom-text">2024년 한경비즈니스 주최 소비자만족지수<br>비대면진료 부문 1위</span>

    </div>
</template>

<script>
import util from '@/utils/utils.js'
export default {
    name: 'banner',
    data: function()
    {
        return {
            abx_tid: null
        }
    },  
    mounted: function()
    {

        $(window).scroll(function () {
            var height = $(document).scrollTop();
            // console.log(height)
            if(height > 223)
            {
                $('#float-button').css('display', `flex`);
            }
        })

        function getAbxTidParameter() {
            var landingPageUrl = window.location.search.substring(1),
                referrerDatas = landingPageUrl.split('&'),
                referrerParamName,
                i;
        
            for (i = 0; i < referrerDatas.length; i++) {
                referrerParamName = referrerDatas[i].split('=');
        
                if (referrerParamName[0] === "abx_tid") {
                    return referrerParamName[1] === undefined ? true : referrerParamName[1];
                }
            }
        };
        this.abx_tid = getAbxTidParameter();
    },
    methods: {
        appDown: function()
        {
            if (!wcs_add) var wcs_add={};
                window.wcs_add = {wa:"s_4b46bc66587"}; //윈도우 객체 선언
                if (!_nasa) var _nasa={};
                if(window.wcs){
                    wcs.inflow();
                    wcs_do();
                }
                
            if(window.wcs){
                if(!wcs_add) var wcs_add = {};
                window.wcs_add = {wa:"s_4b46bc66587"}; //윈도우 객체 선언
                var _conv = {};
                    _conv.type = 'lead';    	
                wcs.trans(_conv);
            }

            // 앱의 스키마 URL
            var appSchemeURL = 'soldoc://home';
            // 안드로이드와 iOS 마켓 URL
            var androidMarketURL = 'https://play.google.com/store/apps/details?id=com.soldocapp';
            var iosMarketURL = 'https://apps.apple.com/kr/app/soldoc-%EB%B9%84%EB%8C%80%EB%A9%B4%EC%A7%84%EB%A3%8C-%EC%86%8C%EB%B9%84%EC%9E%90%EB%A7%8C%EC%A1%B1%EC%A7%80%EC%88%98-1%EC%9C%84/id1667730511';

            if(this.abx_tid !== undefined)
            {
                appSchemeURL = 'soldoc://home?abx_tid=' + this.abx_tid;
                androidMarketURL = 'https://play.google.com/store/apps/details?id=com.soldocapp&referrer=abx_tid%3D' + this.abx_tid;  // Google Play 스토어 링크
                iosMarketURL = 'https://apps.apple.com/kr/app/%EC%86%94%EB%8B%A5-%EB%B9%84%EB%8C%80%EB%A9%B4%EC%A7%84%EB%A3%8C-%EC%86%8C%EB%B9%84%EC%9E%90%EB%A7%8C%EC%A1%B1%EC%A7%80%EC%88%98-1%EC%9C%84/id1667730511?&referrer=abx_tid%3D' + this.abx_tid;  //appstore 스토어 링크
            }
            
            
            // 리다이렉트를 체크할 시간 간격
            var timeoutMs = 2000;

            // 앱 실행 시도
            window.location.href = appSchemeURL;

            // 2초 후에 페이지 가시성 체크
            setTimeout(function() {
                if (document.visibilityState === 'visible') {
                    // 사용자의 기기에 따라 적절한 마켓으로 리다이렉트
                    if (navigator.userAgent.match(/Android/i)) {
                        window.location.href = androidMarketURL;
                    } else if (navigator.userAgent.match(/iPhone|iPad/i)) {
                        window.location.href = iosMarketURL;
                    }
                }
            }, timeoutMs);   
        }
    }
}
</script>

<style scoped>
    .banner {
        width: 100%;
        position: relative;
    }
    .bg-video {
        width: 100%;
        margin-top: 0px;
    }
    .bg-logo {
        position: absolute;
        top: 32px;
        left: 50%;
        transform: translate(-50%, 0);
        width: 74px;
        z-index: 1;
    }
    .center-area {
        position: absolute;
        z-index: 1;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;

    }

    .bottom-text {
        color: #999;
        text-align: center;
        font-family: Pretendard;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px; /* 140% */
        position:absolute;
        bottom: 36px;
        z-index: 10;
        left: 50%;
        transform: translate(-50%, 0);
    }
    .text-sub {
        color: #CCC;
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .text-title {
        color: #FFF;
        text-align: center;
        font-family: Pretendard;
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px; /* 126.667% */
        margin-top: 12px;
    }
    .bg-block {
        position: absolute;
        width: 100%;
        height: calc(100% - 3px);
        background: rgba(0, 0, 0, 0.5);
        top: 0;
        left: 0;
        z-index: 0;
    }
    .down-button {
        display: flex;
        padding: 8px 22px 8px 20px;
        justify-content: center;
        align-items: center;
        gap: 2px;
        border-radius: 22px;
        background: #008DEF;
        color: #FFF;
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px; /* 185.714% */
        width: 128px;
        margin-top: 17px;
        cursor: pointer;
    }

    .download-logo {
        width: 20px;
    }

    .float-button {
        display: flex;
        height: 54px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 6px;
        background: #008DEF;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.16);
        /* animation: fadeInUp1 2s;
        display: none; */
        position: fixed;
        width: calc(100% - 40px);
        margin-left: 20px;
        z-index: 999;
        bottom: 20px;
        animation: fadeInUp1 1s;
        display: none;
        color: #FFF;

        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 17px; /* 106.25% */
        cursor: pointer;
    }

    @media (min-width: 960px) {
        .float-button {
            display: flex;
            height: 54px;
            justify-content: center;
            align-items: center;
            border-radius: 6px;
            background: #008DEF;
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.16);
            animation: fadeInUp1 1s;
            display: none;
            position: fixed;
            width: 335px;
            margin-left: 20px;
            z-index: 999;
            bottom: 20px;
            color: #FFF;

            text-align: center;
            font-family: Pretendard;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 17px; /* 106.25% */
            cursor: pointer;

        }
    }


    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Banner.vue